<div class="custom" style="height: 100%; width: 100%">
  <div class="maintenance">
    <div class="container">
      <div class="row">
        <div class="col text-center">
          <div class="h1-eq">The course is locked.</div>
          <div class="h3-eq">
            Please click the button below when the course is opened again ...
          </div>
          <button
            type="button"
            onclick="document.location.reload(true)"
            class="btn text-uppercase"
          >
            Refresh
          </button>
          <div class="h3-eq">© Megalearning</div>
        </div>
      </div>
    </div>
  </div>
</div>
